import AdminRequest from './AdminRequest';
import CRUD from './CRUD';

/**
 * Provides a set of CRUD operations around API: /system/status.
 */
export class SystemStatusClient extends CRUD {
	constructor() {
		super('/system/status', 'id', { timeout: 3000 }); // url, idProperty, timeout
	}

	get() {
		return super.getAll();
	}
}

export default class SystemClient extends AdminRequest {
	constructor() {
		super('/system');
	}

	getConfig() {
		return this._op('get', `${this.uri}/config`);
	}

	restart() {
		return this._op('get', `${this.uri}/reload`);
	}
}
